<template>
	<div>
    <!-- <iframe></iframe> -->
	</div>
</template>

<script>
import SecurityService from '@/js/util/SecurityService.js'
// import config from '@/config/index'
export default {
  name: 'Login',
  data () {
    return {
      securityService: new SecurityService()
    }
  },
  mounted () {
    this.redirentLogin()
  },
  methods: {
    redirentLogin () {
      this.$store.commit('setLogoutDialog', false)
      this.$oAuth.signIn()
    }
  }
}
</script>
